export const FormSamplesSettingValuesDynamicallyPageInfo = () => {
    return (
        <>
            This example only shows the cities/towns for the country selected. The city/town drop down is updated dynamically
            when a country is changed.<br />
            It users the form hooks setItem to set the city/town based on country.<br />
            You can use the setItem and getItem hooks to set or get items from the form.
        </>
    )
}
